module.exports = __webpack_public_path__ + "static/img/05img.bf8604f7.jpg";